import React from "react";
import { calculateWorkingDayDifference } from "../../../utils/helperUtils";

interface DateShiftBadgesProps {
  liveStart: string;
  simStart: string;
  liveEnd: string;
  simEnd: string;
  organizationWorkingDays: number[];
  organizationHolidays: { date: string }[];
}

const DateShiftBadges: React.FC<DateShiftBadgesProps> = ({
  liveStart,
  simStart,
  liveEnd,
  simEnd,
  organizationWorkingDays,
  organizationHolidays,
}) => {
  const startDayDiff = calculateWorkingDayDifference(
    liveStart,
    simStart,
    organizationWorkingDays,
    organizationHolidays
  );

  const endDayDiff = calculateWorkingDayDifference(
    liveEnd,
    simEnd,
    organizationWorkingDays,
    organizationHolidays
  );

  const colorClasses = (diff: number) =>
    diff < 0 ? "text-[#1d8961] dark:text-[#2ccc92]" : "text-red-600 dark:text-red-400";

  return (
    <>
      {startDayDiff !== 0 && (
        <div
          className={`
            absolute -top-6 left-2 text-xs font-medium pointer-events-none z-[9999] 
            ${colorClasses(startDayDiff)}
          `}
          style={{ fontSize: 10 }}
          title={`Start date shifted by ${startDayDiff > 0 ? "+" : ""}${startDayDiff} working days`}
        >
          {startDayDiff > 0 ? "+" : ""}
          {startDayDiff}d
        </div>
      )}

      {endDayDiff !== 0 && (
        <div
          className={`absolute -top-5 -right-3 text-xs font-medium pointer-events-none z-[9999] cursor-pointer 
            ${colorClasses(endDayDiff)}
          `}
          style={{ fontSize: 10 }}
          title={`End date shifted by ${endDayDiff > 0 ? "+" : ""}${endDayDiff} working days`}
        >
          {endDayDiff > 0 ? "+" : ""}
          {endDayDiff}d
        </div>
      )}
    </>
  );
};

export default DateShiftBadges; 